// REA-CI/screens/BuyerProfileScreen.tsx

import React, { useState } from "react";
import {
  View,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  Alert,
  ScrollView,
  Image,
} from "react-native";
import { FontAwesome } from "@expo/vector-icons";
import CountryFlag from "react-native-country-flag";

const BuyerProfileScreen = ({ navigation }: any) => {
  const [fullName, setFullName] = useState("John Doe");
  const [username, setUsername] = useState("johndoe");
  const [city, setCity] = useState("Abidjan");
  const [phoneNumber, setPhoneNumber] = useState("+22512345678");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [viewedProperties, setViewedProperties] = useState([
    { id: "1", title: "Modern Villa", location: "Grand-Bassam, Abidjan" },
    { id: "2", title: "Family House", location: "Deux-Plateaux, Abidjan" },
  ]);

  const updatePassword = () => {
    if (currentPassword && newPassword) {
      Alert.alert("Success", "Password updated successfully!");
      setCurrentPassword("");
      setNewPassword("");
    } else {
      Alert.alert("Error", "Please provide the current and new passwords.");
    }
  };

  const deleteAccount = () => {
    Alert.alert(
      "Delete Account",
      "Are you sure you want to delete your account? This action cannot be undone.",
      [
        { text: "Cancel", style: "cancel" },
        {
          text: "Delete",
          style: "destructive",
          onPress: () => Alert.alert("Account deleted."),
        },
      ]
    );
  };

  const logout = () => {
    Alert.alert("Logout", "You have been logged out.");
    navigation.navigate("WelcomeScreen");
  };

  return (
    <ScrollView contentContainerStyle={styles.container}>
      <View style={styles.profileContainer}>
        <Image
          source={{ uri: "https://via.placeholder.com/100" }}
          style={styles.profileImage}
        />
        <Text style={styles.name}>{fullName}</Text>
        <Text style={styles.username}>@{username}</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Profile Information</Text>
        <Text>Full Name:</Text>
        <TextInput
          style={styles.input}
          value={fullName}
          onChangeText={setFullName}
          placeholder="Full Name"
        />
       <Text>Username:</Text>
        <TextInput
          style={styles.input}
          value={username}
          onChangeText={setUsername}
          placeholder="Username"
        />
        <Text>City:</Text>
        <TextInput
          style={styles.input}
          value={city}
          onChangeText={setCity}
          placeholder="City"
        />
        <View style={styles.phoneContainer}>
          <CountryFlag isoCode="CI" size={20} style={styles.flag} />
          <TextInput
            style={[styles.input, styles.phoneInput]}
            value={phoneNumber}
            onChangeText={setPhoneNumber}
            placeholder="Phone Number"
          />
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Update Password</Text>
        <TextInput
          style={styles.input}
          secureTextEntry
          value={currentPassword}
          onChangeText={setCurrentPassword}
          placeholder="Current Password"
        />
        <TextInput
          style={styles.input}
          secureTextEntry
          value={newPassword}
          onChangeText={setNewPassword}
          placeholder="New Password"
        />
        <TouchableOpacity style={styles.button} onPress={updatePassword}>
          <Text style={styles.buttonText}>Update Password</Text>
        </TouchableOpacity>
      </View>

      <View style={styles.section}>
        <Text style={styles.sectionTitle}>viewed properties</Text>
        {viewedProperties.map((property) => (
          <View key={property.id} style={styles.propertyItem}>
            <Text>{property.title}</Text>
            <Text style={styles.propertyLocation}>{property.location}</Text>
          </View>
        ))}
      </View>

      <TouchableOpacity
        style={[styles.button, styles.deleteButton]}
        onPress={deleteAccount}
      >
        <Text style={styles.buttonText}>Delete Account</Text>
      </TouchableOpacity>
      <TouchableOpacity style={styles.button} onPress={logout}>
        <Text style={styles.buttonText}>Logout</Text>
      </TouchableOpacity>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 20,
    backgroundColor: "#f8f8f8",
  },
  profileContainer: {
    alignItems: "center",
    marginBottom: 20,
  },
  profileImage: {
    width: 100,
    height: 100,
    borderRadius: 50,
    marginBottom: 10,
  },
  name: {
    fontSize: 18,
    fontWeight: "bold",
  },
  username: {
    fontSize: 14,
    color: "#777",
  },
  section: {
    marginBottom: 20,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: "bold",
    marginBottom: 10,
    textTransform: "lowercase", // Added lowercase text style
  },
  input: {
    backgroundColor: "#fff",
    padding: 10,
    borderRadius: 5,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: "#ddd",
  },
  phoneContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  flag: {
    marginRight: 10,
  },
  phoneInput: {
    flex: 1,
  },
  button: {
    backgroundColor: "green",
    padding: 15,
    borderRadius: 5,
    alignItems: "center",
    marginBottom: 10,
  },
  deleteButton: {
    backgroundColor: "red",
  },
  buttonText: {
    color: "#fff",
    fontWeight: "bold",
  },
  propertyItem: {
    padding: 10,
    backgroundColor: "#fff",
    borderRadius: 5,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: "#ddd",
  },
  propertyLocation: {
    fontSize: 12,
    color: "#777",
  },
});

export default BuyerProfileScreen;
